/**
 * @Class :        group
 * @Author :       sitDownSir(刘立)
 * @CreateDate :   2018-07-20 17:20
 * @Description :   扩展组件
 * @version :
 **/
function padLeftZero(str) {
  return ('00' + str).substr(str.length);
}

const Group = {
  //获取地址栏参数
  getUrlArg(name) {
    let reg = new RegExp("(^|\\?|&)" + name + "=([^&]*)(\\s|&|$)", "i");
    if (reg.test(window.location.href)) {
      return unescape(RegExp.$2.replace(/\+/g, " "))
    }
    return undefined
  },

  //清除cookie
  clearCookie() {
    var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
    if (keys) {
      for (var i = keys.length; i--;) {
        document.cookie =
          keys[i] + "=0;path=/;expires=" + new Date(0).toUTCString(); //清除当前域名下的,例如：m.kevis.com
        document.cookie =
          keys[i] +
          "=0;path=/;domain=" +
          document.domain +
          ";expires=" +
          new Date(0).toUTCString(); //清除当前域名下的，例如 .m.kevis.com
        document.cookie =
          keys[i] +
          "=0;path=/;domain=kevis.com;expires=" +
          new Date(0).toUTCString(); //清除一级域名下的或指定的，例如 .kevis.com
      }
    }
  },

  //去掉字符所有空格 (第二个参数为g)
  allTrim(str) {
    var result;
    result = str.replace(/\s+/g, "");
    result = result.replace(/\s/g, '');
    result = result.replace(/<\/?.+?>/g, "");
    result = result.replace(/[\r\n]/g, "");

    return result;
  },

  //格式化日期
  formatDate(date, fmt) {
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    let o = {
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),
      'h+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds()
    };
    for (let k in o) {
      if (new RegExp(`(${k})`).test(fmt)) {
        let str = o[k] + '';
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
      }
    }
    return fmt;
  },

  //根据日期判断年龄
  birthdayToAge(strBirthday) {
    var returnAge;
    var strBirthdayArr = strBirthday.split("-");
    var birthYear = strBirthdayArr[0];
    var birthMonth = strBirthdayArr[1];
    var birthDay = strBirthdayArr[2];

    var d = new Date();
    var nowYear = d.getFullYear();
    var nowMonth = d.getMonth() + 1;
    var nowDay = d.getDate();

    if (nowYear == birthYear) {
      returnAge = 0;//同年 则为0岁
    } else {
      var ageDiff = nowYear - birthYear; //年之差
      if (ageDiff > 0) {
        if (nowMonth == birthMonth) {
          var dayDiff = nowDay - birthDay;//日之差
          if (dayDiff < 0) {
            returnAge = ageDiff - 1;
          } else {
            returnAge = ageDiff;
          }
        } else {
          var monthDiff = nowMonth - birthMonth;//月之差
          if (monthDiff < 0) {
            returnAge = ageDiff - 1;
          } else {
            returnAge = ageDiff;
          }
        }
      } else {
        returnAge = -1;//返回-1 表示出生日期输入错误 晚于今天
      }
    }

    return returnAge;//返回周岁年龄

  },

  //随机取色
  getRandomColor() {
    var rand = Math.floor(Math.random() * 0xFFFFFF).toString(16);
    if (rand.length === 6) {
      return rand;
    } else {
      return Group.getRandomColor();
    }
  },

  //@身份证
  identityCard: {
    //性别
    sex(psidno) {
      let sexno, sex
      if (psidno.length == 18) {
        sexno = psidno.substring(16, 17)
      } else if (psidno.length == 15) {
        sexno = psidno.substring(14, 15)
      } else {
        return "error"
      }
      let tempid = sexno % 2;
      if (tempid == 0) {
        sex = 'woman'
      } else {
        sex = 'man'
      }
      return sex
    },

    //出生年月日
    birthday(psidno) {
      let birthdayno, birthdaytemp
      if (psidno.length == 18) {
        birthdayno = psidno.substring(6, 14)
      } else if (psidno.length == 15) {
        birthdaytemp = psidno.substring(6, 12)
        birthdayno = "19" + birthdaytemp
      } else {
        alert("错误的身份证号码，请核对！")
        return false
      }
      let birthday = birthdayno.substring(0, 4) + "-" + birthdayno.substring(4, 6) + "-" + birthdayno.substring(6, 8)
      return birthday
    },
  }
};


export default Group;



// WEBPACK FOOTER //
// ./src/assets/lib/group.js